import createSagaMiddleware from 'redux-saga';
import { createStore, compose, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { Env } from './constants/env';

import createRootReducer from './reducers';
import rootSaga from './sagas';
import { logError } from './utils/ErrorLogger';
import { badgesMiddleware } from './containers/Badges/middleware';
import { appStateRestored } from './containers/App/actions';

const composeEnhancers =
  (process.env.NODE_ENV === Env.DEVELOPMENT &&
    // @ts-ignore
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
};

const configureStore = (initialState = {}, history: any) => {
  const sagaMiddleware = createSagaMiddleware({
    onError(error: Error): void {
      logError(error);
    },
  });

  const middlewares = [sagaMiddleware, routerMiddleware(history), badgesMiddleware];

  const rootReducer = createRootReducer(history);
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(persistedReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));

  const persistor = persistStore(store, {}, () => {
    store.dispatch(appStateRestored());
  });

  sagaMiddleware.run(rootSaga);

  return { store, persistor };
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.ts